import React, { useRef, createContext } from "react";

export const RefContext = createContext(undefined);

export const RefProvider = ({ children }) => {
  const componentSize = useRef({});
  const spiderRef = useRef(null);
  const layoutRefs = useRef({
    filterCursor: {},
    filterStart: {},
    brush: {},
    pxRange: { min: undefined, max: undefined },
  });

  const refs = { componentSize, layoutRefs, spiderRef };

  return refs ? (
    <RefContext.Provider value={refs}>{children}</RefContext.Provider>
  ) : null;
};
